import {
  tabCloser, tabIcons, tabTemplate, categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeThemes } from '../actions';
import ThemesActions from '../components/ThemesActions';
import ThemesPanel from '../components/ThemesPanel';

export default {
  ...tabTemplate('themes', ThemesPanel, matchSingleUrl(['themes']), ThemesActions),
  ...tabCloser('closeThemesTab', closeThemes),
  ...tabIcons('paint brush'),
  access: ({ themes }) => themes.update,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 1000,
};
